import React, { useState } from 'react'
import './style.scss'

const EventTemplateStrip = ({
  title = 'Event template',
  subTitle = 'Pre-fill this form using a saved template',
  onDownloadTemplate,
  onUploadTemplate,
  initialFileName = '',
  sampleUrl = '/misc/sample.xlsx',
}) => {
  const [fileName, setFileName] = useState(initialFileName)

  const handleDownload = (e) => {
    if (onDownloadTemplate) {
      onDownloadTemplate(e)
    } else {
      const link = document.createElement('a')
      link.href = sampleUrl
      link.download = sampleUrl.substring(sampleUrl.lastIndexOf('/') + 1) || 'sample.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const handleTemplateUpload = (e) => {
    const file = e.target.files && e.target.files[0]
    if (file) {
      setFileName(file.name)
      if (onUploadTemplate) {
        onUploadTemplate(file, e)
      }
    }
  }

  return (
    <div className='template-strip'>
      <svg
        className='template-strip-icon'
        width='14'
        height='14'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#B4B2A9'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
        <polyline points='14 2 14 8 20 8' />
      </svg>
      <div className='template-strip-content'>
        <div className='template-strip-title'>{title}</div>
        <div className='template-strip-sub'>{subTitle}</div>
      </div>
      <div className='template-strip-actions'>
        <a
          href={sampleUrl}
          download
          className='template-strip-btn'
          onClick={handleDownload}
        >
          <svg
            width='12'
            height='12'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
            <polyline points='7 10 12 15 17 10' />
            <line x1='12' y1='15' x2='12' y2='3' />
          </svg>
          Download template
        </a>
        <label className='template-strip-upload'>
          <svg
            width='12'
            height='12'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
            <polyline points='17 8 12 3 7 8' />
            <line x1='12' y1='3' x2='12' y2='15' />
          </svg>
          Upload
          <input
            type='file'
            accept='.xls,.xlsx,.csv'
            onChange={handleTemplateUpload}
          />
        </label>
      </div>
      <div
        id='template-filename'
        className={`template-filename ${fileName ? '' : 'hidden'}`}
      >
        {fileName ? `Uploaded: ${fileName}` : ''}
      </div>
    </div>
  )
}

export default EventTemplateStrip
